import { createBrowserRouter, type RouteObject } from "react-router";

import { AppLayout } from "@/components/layout/app-shell";
import { RequireAuth } from "@/components/layout/require-auth";
import { RouteError } from "@/components/layout/route-error";

export const routes: RouteObject[] = [
  {
    path: "/login",
    lazy: () => import("./pages/login-page").then((m) => ({ Component: m.LoginPage })),
    errorElement: <RouteError />,
  },
  {
    element: <RequireAuth />,
    errorElement: <RouteError />,
    children: [
      {
        element: <AppLayout />,
        children: [
          { index: true, lazy: () => import("./pages/overview-page").then((m) => ({ Component: m.OverviewPage })) },
          {
            path: "transacciones",
            lazy: () => import("./pages/transactions-page").then((m) => ({ Component: m.TransactionsPage })),
          },
          { path: "cuentas", lazy: () => import("./pages/accounts-page").then((m) => ({ Component: m.AccountsPage })) },
          {
            path: "cuentas/:id",
            lazy: () => import("./pages/account-detail-page").then((m) => ({ Component: m.AccountDetailPage })),
          },
          { path: "gastos", lazy: () => import("./pages/spending-page").then((m) => ({ Component: m.SpendingPage })) },
          {
            path: "recurrentes",
            lazy: () => import("./pages/recurring-page").then((m) => ({ Component: m.RecurringPage })),
          },
          { path: "ajustes", lazy: () => import("./pages/settings-page").then((m) => ({ Component: m.SettingsPage })) },
          { path: "*", lazy: () => import("./pages/not-found-page").then((m) => ({ Component: m.NotFoundPage })) },
        ],
      },
    ],
  },
];

export const router = createBrowserRouter(routes);
